/* eslint-disable max-lines */
/* eslint-disable no-magic-numbers */
/* eslint-disable object-curly-newline */
import TotalGraph from "@/components/totalGraph/totalGraph.vue";
import EdibleVsInedibleWaste from "@/components/edibleVsInedibleWaste/edibleVsInedibleWaste.vue";
import SourcesOfEdibleWaste from "@/components/sourcesOfEdibleWaste/sourcesOfEdibleWaste.vue";
import TopWastedCategories from "@/components/topWastedCategories/topWastedCategories.vue";
import TopWastedItemsTrashEvents from "@/components/topWastedItemsTrashEvents/topWastedItemsTrashEvents.vue";
import AverageWastePerGuestPerDay from "@/components/averageWastePerGuestPerDay/averageWastePerGuestPerDay.vue";
import { REQUEST_STATE, STATUS_CODE } from "@/enums";
import { CategoryService } from "@/services/categoryApi";
import InfoCardStat from "@/components/infoCardStat/InfoCardStat.vue";
import weightIcon from "@/assets/img/total-2.svg";
import costIcon from "@/assets/img/total-1.svg";
import redArrow from "@/assets/img/arrow-red.svg";
import greenArrow from "@/assets/img/arrow-green.svg";
import WastePerGuestPerServiceTime from "@/components/wastePerGuestPerServiceTime/wastePerGuestPerServiceTime.vue";
import { ChevronDownIcon, ChevronUpIcon } from "vue-feather-icons";
import ServiceTimes from "@/components/serviceTimes/serviceTimes.vue";
import { isAverageComparison, comparator } from "@/utils";

import { createNamespacedHelpers } from "vuex";

const { mapGetters: filtersGetters } = createNamespacedHelpers("filters");

export default {
	components: {
		TotalGraph,
		EdibleVsInedibleWaste,
		SourcesOfEdibleWaste,
		TopWastedCategories,
		WastePerGuestPerServiceTime,
		InfoCardStat,
		ChevronDownIcon,
		ChevronUpIcon,
		TopWastedItemsTrashEvents,
		AverageWastePerGuestPerDay,
		ServiceTimes,
	},
	computed: {
		...filtersGetters(["activeWasteType", "activePeriod", "activeCompareTo"]),
		period,
		wasteWeight,
		wasteCost,
		wastePerGuestWeight,
		wastePerGuestCost,
		readyToPrint,
	},

	methods: {
		loadData,
		getWeightCostData,
		setWasteWeightStatus,
		setWasteCostStatus,
		getWastePerGuestData,
		setWastePerGuestStatus,
		getWasteSourceAndServiceTimes,
		getCategories,
		printPage,
	},

	data() {
		return {
			isAvoidableWasteGraphVisible: false,

			wasteSourceServiceTimes: {
				data: {},
				state: REQUEST_STATE.LOADING,
			},

			categories: {
				data: [],
				state: REQUEST_STATE.LOADING,
			},

			weightIcon,
			costIcon,
			redArrow,
			greenArrow,
			wasteWeightCostData: {
				current: {
					cost: 0,
					total_waste: 0,
				},
				comparator: {
					cost: 0,
					total_waste: 0,
				},
			},
			wasteWeightStatus: {},
			wasteCostStatus: {},
			wasteWeightCostDataStatus: {},
			wastePerGuestData: {
				showLoader: true,
				current: {
					data: {},
					done: false,
					success: false,
				},
				comparator: {
					data: {},
					done: false,
					success: false,
				},
			},
			wastePerGuestWeightStatus: {},
			wastePerGuestCostStatus: {},
			showWastePerGuestPerServiceTimes: false,
		};
	},
	created() {
		this.loadData();
		this.$eventBus.$on("reloadComponentData", this.loadData);
	},

	beforeDestroy() {
		this.$eventBus.$off("reloadComponentData", this.loadData);
	},
};

function loadData() {
	this.getWasteSourceAndServiceTimes();
	this.getCategories();
	this.getWeightCostData();
	this.getWastePerGuestData();
}

async function getCategories() {
	try {
		this.categories.state = REQUEST_STATE.LOADING;

		const { data } = await CategoryService.getCategoryOverview();
		this.categories.data = data;

		this.categories.state = REQUEST_STATE.SUCCESS;
	} catch (error) {
		if (error.response?.status === STATUS_CODE.MISSING_DATA) this.categories.state = REQUEST_STATE.MISSING_DATA;
	}
}

async function getWasteSourceAndServiceTimes() {
	try {
		this.wasteSourceServiceTimes.state = REQUEST_STATE.LOADING;
		const { data } = await this.$api.getWasteSourceAndServiceTimes();

		this.wasteSourceServiceTimes.data = data;
		this.wasteSourceServiceTimes.state = REQUEST_STATE.SUCCESS;
	} catch (error) {
		if (error.response?.status === STATUS_CODE.MISSING_DATA)
			this.wasteSourceServiceTimes.state = REQUEST_STATE.MISSING_DATA;
	}
}

function setWasteWeightStatus() {
	this.wasteWeightStatus = isAverageComparison(this.activeCompareTo)
		? comparator(this.wasteWeightCostData.current.wpg, this.wasteWeightCostData.comparator.wpg)
		: comparator(this.wasteWeightCostData.current.total_weight, this.wasteWeightCostData.comparator.total_weight);
}

function setWasteCostStatus() {
	this.wasteCostStatus = isAverageComparison(this.activeCompareTo)
		? comparator(this.wasteWeightCostData.current.cpg, this.wasteWeightCostData.comparator.cpg)
		: comparator(this.wasteWeightCostData.current.total_cost, this.wasteWeightCostData.comparator.total_cost);
}

function setWastePerGuestStatus() {
	this.wastePerGuestWeightStatus = comparator(
		this.wastePerGuestData.current.data.totals.wpg,
		this.wastePerGuestData.comparator.data.totals.wpg
	);
	this.wastePerGuestCostStatus = comparator(
		this.wastePerGuestData.current.data.totals.cpg,
		this.wastePerGuestData.comparator.data.totals.cpg
	);
}

function period() {
	return this.activePeriod === "day" ? "for_day" : "for_period";
}

// eslint-disable-next-line complexity
async function getWeightCostData() {
	this.wasteWeightCostDataStatus = {
		showLoader: true,
		dataLoadFailed: false,
		compareDataLoadFailed: false,
	};

	try {
		this.wasteWeightCostData.current = (await this.$api.getWasteWeightCost()).data;
	} catch (error) {
		if (error.message !== "CANCELED_CALL") this.wasteWeightCostDataStatus.dataLoadFailed = true;
	}

	try {
		this.wasteWeightCostData.comparator = (await this.$api.getWasteWeightCost(true)).data;
	} catch (error) {
		if (error.message !== "CANCELED_COMPARE_CALL") this.wasteWeightCostDataStatus.compareDataLoadFailed = true;
	}

	this.wasteWeightCostDataStatus.showLoader = false;
	this.setWasteWeightStatus();
	this.setWasteCostStatus();
}

function wasteWeight() {
	return this.wasteWeightCostData.current.total_weight
		? Math.round(this.wasteWeightCostData.current.total_weight / 1000)
		: 0;
}

function wasteCost() {
	return this.wasteWeightCostData.current.total_cost ? Math.round(this.wasteWeightCostData.current.total_cost) : 0;
}

// eslint-disable-next-line complexity
async function getWastePerGuestData() {
	this.wastePerGuestData = {
		showLoader: true,
		current: {
			data: {},
			done: false,
			success: false,
		},
		comparator: {
			data: {},
			done: false,
			success: false,
		},
	};

	// the following calls are async to save time...

	this.$api
		.getWastePerGuestPerServiceTime()
		.then(({ data }) => {
			this.wastePerGuestData.current.data = data;
			this.wastePerGuestData.current.success = true;
		})
		.catch((error) => {
			// TODO: put the actual state here
			if (error.message !== "CANCELED_CALL") this.wastePerGuestData.current.success = false;
		})
		.finally(() => {
			this.wastePerGuestData.current.done = true;

			if (this.wastePerGuestData.current.done && this.wastePerGuestData.comparator.done) {
				this.wastePerGuestData.showLoader = false;
				this.setWastePerGuestStatus();
			}
		});

	this.$api
		.getWastePerGuestPerServiceTime(true)
		.then(({ data }) => {
			this.wastePerGuestData.comparator.data = data;
			this.wastePerGuestData.comparator.success = true;
		})
		.catch((error) => {
			if (error.message !== "CANCELED_CALL") this.wastePerGuestData.comparator.success = false;
		})
		.finally(() => {
			this.wastePerGuestData.comparator.done = true;

			if (this.wastePerGuestData.current.done && this.wastePerGuestData.comparator.done) {
				this.wastePerGuestData.showLoader = false;
				this.setWastePerGuestStatus();
			}
		});
}

function wastePerGuestWeight() {
	return this.wastePerGuestData.current.data.totals.wpg || 0;
}

function wastePerGuestCost() {
	return this.wastePerGuestData.current.data.totals.cpg || 0;
}

function printPage() {
	this.$utils.printPage(this);
}

function readyToPrint() {
	return (
		this.categories.state === REQUEST_STATE.SUCCESS && this.wasteSourceServiceTimes.state === REQUEST_STATE.SUCCESS
	);
}
